// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAckStatus = z.enum([
    'accepted',
    'duplicate',
    'rejected'
]);

export type AckStatus = z.infer<typeof zAckStatus>;

export const zBumpItemVersionResponse = z.object({
    itemId: z.string(),
    version: z.int(),
    servedAt: z.int()
});

export type BumpItemVersionResponse = z.infer<typeof zBumpItemVersionResponse>;

export const zCreateSessionRequest = z.object({
    descriptorId: z.string(),
    preparationId: z.string().nullish(),
    elapsedSecOverride: z.int().nullish()
});

export type CreateSessionRequest = z.infer<typeof zCreateSessionRequest>;

export const zDevSubscription = z.object({
    id: z.string(),
    transport: z.string(),
    target: z.string(),
    label: z.string().nullable(),
    createdAt: z.int(),
    stale: z.boolean()
});

export type DevSubscription = z.infer<typeof zDevSubscription>;

export const zEntitlement = z.object({
    tier: z.string(),
    validUntil: z.int()
});

export type Entitlement = z.infer<typeof zEntitlement>;

export const zGetMeResponse = z.object({
    userId: z.string(),
    displayName: z.string(),
    entitlement: zEntitlement,
    servedAt: z.int()
});

export type GetMeResponse = z.infer<typeof zGetMeResponse>;

export const zGetVapidPublicKeyResponse = z.object({
    publicKey: z.string(),
    servedAt: z.int()
});

export type GetVapidPublicKeyResponse = z.infer<typeof zGetVapidPublicKeyResponse>;

export const zItemResult = z.object({
    itemId: z.string(),
    correct: z.boolean(),
    versionConflict: z.boolean()
});

export type ItemResult = z.infer<typeof zItemResult>;

export const zCompleteSessionResponse = z.object({
    sessionId: z.string(),
    rawScore: z.int(),
    maxScore: z.int(),
    percentile: z.int(),
    durationOverrunFlagged: z.boolean(),
    perItem: z.array(zItemResult),
    completedAt: z.int(),
    servedAt: z.int()
});

export type CompleteSessionResponse = z.infer<typeof zCompleteSessionResponse>;

export const zJsonNode = z.unknown();

export type JsonNode = z.infer<typeof zJsonNode>;

export const zItemPayload = z.object({
    id: z.string(),
    version: z.int(),
    type: z.string(),
    groupId: z.string().nullable(),
    content: zJsonNode,
    correctAnswer: zJsonNode.nullable(),
    explanation: zJsonNode.nullable(),
    assetIds: z.array(z.string()),
    servedAt: z.int()
});

export type ItemPayload = z.infer<typeof zItemPayload>;

export const zLoginStubRequest = z.object({
    displayName: z.string().nullish()
});

export type LoginStubRequest = z.infer<typeof zLoginStubRequest>;

export const zLoginUser = z.object({
    id: z.string(),
    displayName: z.string()
});

export type LoginUser = z.infer<typeof zLoginUser>;

export const zLoginStubResponse = z.object({
    accessToken: z.string(),
    expiresInSec: z.int(),
    user: zLoginUser,
    servedAt: z.int()
});

export type LoginStubResponse = z.infer<typeof zLoginStubResponse>;

export const zPrepareSessionRequest = z.object({
    descriptorId: z.string()
});

export type PrepareSessionRequest = z.infer<typeof zPrepareSessionRequest>;

export const zPrepareSessionResponse = z.object({
    preparationId: z.string(),
    descriptorId: z.string(),
    itemIds: z.array(z.string()),
    servedAt: z.int(),
    items: z.array(zItemPayload)
});

export type PrepareSessionResponse = z.infer<typeof zPrepareSessionResponse>;

export const zProblemDetails = z.object({
    type: z.string().nullish(),
    title: z.string().nullish(),
    status: z.int().nullish(),
    detail: z.string().nullish(),
    instance: z.string().nullish()
});

export type ProblemDetails = z.infer<typeof zProblemDetails>;

export const zPushSendResult = z.object({
    transport: z.string(),
    target: z.string(),
    status: z.string(),
    detail: z.string().nullable()
});

export type PushSendResult = z.infer<typeof zPushSendResult>;

export const zPushSubscriptionKeys = z.object({
    p256dh: z.string().nullable(),
    auth: z.string().nullable()
});

export type PushSubscriptionKeys = z.infer<typeof zPushSubscriptionKeys>;

export const zPushTransport = z.enum(['webpush', 'fcm']);

export type PushTransport = z.infer<typeof zPushTransport>;

export const zRecommendation = z.object({
    descriptorId: z.string(),
    title: z.string(),
    body: z.string()
});

export type Recommendation = z.infer<typeof zRecommendation>;

export const zRegistrationAttempt = z.object({
    at: z.int(),
    transport: z.string(),
    outcome: z.string(),
    detail: z.string(),
    origin: z.string(),
    agent: z.string()
});

export type RegistrationAttempt = z.infer<typeof zRegistrationAttempt>;

export const zDevPushState = z.object({
    statePath: z.string(),
    statePersistable: z.boolean(),
    vapidPublicKey: z.string(),
    vapidKeySource: z.string(),
    fcmConfigured: z.boolean(),
    fcmDisabledReason: z.string().nullable(),
    recentRegistrationAttempts: z.array(zRegistrationAttempt),
    subscriptions: z.array(zDevSubscription)
});

export type DevPushState = z.infer<typeof zDevPushState>;

export const zResponseAck = z.object({
    id: z.string(),
    status: zAckStatus,
    reason: z.string().nullish(),
    correct: z.boolean().nullish(),
    itemVersionOnServer: z.int().nullish(),
    versionConflict: z.boolean().nullish()
});

export type ResponseAck = z.infer<typeof zResponseAck>;

export const zSendTestPushResponse = z.object({
    title: z.string(),
    body: z.string(),
    url: z.string(),
    webPushConfigured: z.boolean(),
    fcmConfigured: z.boolean(),
    fcmDisabledReason: z.string().nullable(),
    vapidKeySource: z.string(),
    statePersistable: z.boolean(),
    subscriptions: z.int(),
    delivered: z.int(),
    skipped: z.int(),
    failed: z.int(),
    pruned: z.int(),
    results: z.array(zPushSendResult),
    servedAt: z.int()
});

export type SendTestPushResponse = z.infer<typeof zSendTestPushResponse>;

export const zSessionKind = z.enum(['drill', 'test']);

export type SessionKind = z.infer<typeof zSessionKind>;

export const zCreateSessionResponse = z.object({
    id: z.string(),
    kind: zSessionKind,
    itemIds: z.array(z.string()),
    startedAt: z.int(),
    durationSec: z.int().nullable(),
    grantToken: z.string(),
    servedAt: z.int(),
    items: z.array(zItemPayload)
});

export type CreateSessionResponse = z.infer<typeof zCreateSessionResponse>;

export const zSessionDescriptor = z.object({
    id: z.string(),
    kind: zSessionKind,
    title: z.string(),
    subtitle: z.string(),
    itemCount: z.int(),
    durationSec: z.int().nullable()
});

export type SessionDescriptor = z.infer<typeof zSessionDescriptor>;

export const zGetPlanResponse = z.object({
    servedAt: z.int(),
    headline: z.string(),
    recommendation: zRecommendation.nullable(),
    descriptors: z.array(zSessionDescriptor)
});

export type GetPlanResponse = z.infer<typeof zGetPlanResponse>;

export const zSessionStatus = z.enum(['active', 'completed']);

export type SessionStatus = z.infer<typeof zSessionStatus>;

export const zGetSessionResponse = z.object({
    id: z.string(),
    kind: zSessionKind,
    itemIds: z.array(z.string()),
    startedAt: z.int(),
    durationSec: z.int().nullable(),
    status: zSessionStatus,
    recordedItemIds: z.array(z.string()),
    servedAt: z.int(),
    items: z.array(zItemPayload)
});

export type GetSessionResponse = z.infer<typeof zGetSessionResponse>;

export const zSessionSummary = z.object({
    id: z.string(),
    kind: zSessionKind,
    startedAt: z.int(),
    durationSec: z.int().nullable(),
    completedAt: z.int().nullable(),
    responseCount: z.int()
});

export type SessionSummary = z.infer<typeof zSessionSummary>;

export const zGetDevStateResponse = z.object({
    sessions: z.array(zSessionSummary),
    itemVersions: z.record(z.string(), z.int()),
    push: zDevPushState,
    serverTime: z.int()
});

export type GetDevStateResponse = z.infer<typeof zGetDevStateResponse>;

export const zSubmitResponsesResponse = z.object({
    acks: z.array(zResponseAck),
    servedAt: z.int()
});

export type SubmitResponsesResponse = z.infer<typeof zSubmitResponsesResponse>;

export const zSubmittedResponse = z.object({
    id: z.string(),
    itemId: z.string(),
    itemVersion: z.int(),
    answer: zJsonNode.nullable(),
    answeredAt: z.int(),
    timeSpentMs: z.int()
});

export type SubmittedResponse = z.infer<typeof zSubmittedResponse>;

export const zSubmitResponsesRequest = z.object({
    responses: z.array(zSubmittedResponse)
});

export type SubmitResponsesRequest = z.infer<typeof zSubmitResponsesRequest>;

export const zSubscribeRequest = z.object({
    transport: z.string(),
    endpoint: z.string().nullish(),
    keys: zPushSubscriptionKeys.nullish(),
    token: z.string().nullish(),
    label: z.string().nullish()
});

export type SubscribeRequest = z.infer<typeof zSubscribeRequest>;

export const zSubscribeResponse = z.object({
    id: z.string(),
    transport: zPushTransport,
    target: z.string(),
    vapidPublicKey: z.string(),
    count: z.int(),
    servedAt: z.int()
});

export type SubscribeResponse = z.infer<typeof zSubscribeResponse>;

export const zUnsubscribeResponse = z.object({
    removed: z.int(),
    count: z.int(),
    servedAt: z.int()
});

export type UnsubscribeResponse = z.infer<typeof zUnsubscribeResponse>;
